var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "result" }, [
    _vm.payStatus == 200
      ? _c("div", { staticClass: "part1" }, [
          _c("img", {
            attrs: { src: require("../../assets/images/img1.png"), alt: "" }
          }),
          _vm._v(" "),
          _c(
            "h4",
            [
              _vm._v("即将获得【健康"),
              _c("font", [_vm._v("直播课")]),
              _vm._v("】")
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn", on: { click: _vm.getRes } }, [
            _vm._v("立即打开")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.payStatus == 200
      ? _c("div", { staticClass: "part2" }, [
          _c("h3", [_vm._v("操作引导")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1)
        ])
      : _c("div", { staticClass: "part3" }, [
          _c("div", { staticClass: "btn", on: { click: _vm.getPay } }, [
            _vm._v("支付失败")
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("即将返回上一页，请耐心等待。。。")])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "num" }, [_vm._v("1")]),
        _vm._v(" "),
        _c("span", { staticClass: "txt" }, [_vm._v("第一步")])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("点击【立即打开】按钮，打开微信")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "num" }, [_vm._v("2")]),
        _vm._v(" "),
        _c("span", { staticClass: "txt" }, [_vm._v("第二步")])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("微信中【添加老师微信】，上直播课")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4830204", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4830204","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay/result.vue
// module id = RFVH
// module chunks = 1